import { render } from "./PerfectIcon.vue?vue&type=template&id=05ab4a8c"
const script = {}

import exportComponent from "/Users/eliott/Developer/Perso/pogodex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__